const Terms = () => {
  return (
    <div className="py-12 text-gray-600">
      <div className="max-w-3xl mx-auto px-4 space-y-8">
        <h1 className="text-3xl font-bold">SHE_LH App 이용약관</h1>

        <div className="space-y-3">
          <h3 className="text-xl font-semibold">1. 약관 수락</h3>
          <p>
            본 협약서를 정독하시기 바랍니다. 계정을 만들거나 앱에 액세스하거나
            앱을 사용함으로써 귀하는 본 협약서의 조건에 동의하고 이를 수락함을
            인정하게 됩니다. 이 약관에 동의하지 않으면 앱에 액세스하거나 앱을
            사용할 수 없습니다.
          </p>
          <p>
            당사는 본 협약서를 수시로 수정할 수 있습니다. 귀하의 권리에 실질적인
            변화를 가할 정도로 수정을 할 경우 당사는 귀하에게 이메일이나 앱으로
            고지하거나, 협약서의 개정판을 제시하여 수락하도록 할 것입니다.
            업데이트 된 협약서 버전이 시행된 날짜 이후에 앱을 계속 사용할 경우,
            귀하는 수정된 협약서를 수락한 것이 됩니다.
          </p>
        </div>

        <div className="space-y-3">
          <h3 className="text-xl font-semibold">2. 의료 서비스 면책 조항</h3>
          <p>
            당사는 의료 면허를 갖춘 의료 제공자가 아니며, 본 앱이 추구하는
            목적은 질병이나 의료 증상에 대한 전문적인 의학적 조언이나 진단, 치료
            또는 관리를 대체하고자 하는데 있지 않으며, 출산 통제 방법이나, 피임
            방법을 제공하고자 하는데 있는 것도 아닙니다. 귀하의 건강이나 안전
            혹은 귀하의 가족이나 태아에게 영향을 줄 수 있는 어떤 결정을 내리거나
            조치를 취하기 전에 면허가 있는 의사나 기타 자격을 갖춘 의료 제공자와
            상담하시기 바랍니다. 본 앱과 관련하여 어떤 내용을 읽었다는 이유로
            전문적인 의학적 조언을 무시하지 않아야 하며 전문적인 의학적 조언을
            구하는 일을 지체하지 않아야 합니다. 만약 건강 및 증상과 관련하여
            궁금한 점이나 염려되는 점이 있을 경우, 또는 증상이나 건강 상태에
            어떠한 변화가 있는 경우, 반드시 의료 전문가와 상담하십시오. 의학적
            응급 상황이라 판단되는 경우에는 즉시 119에 전화하거나 가까운
            응급실로 가시기 바랍니다.
          </p>
          <p>
            당사는 여하한 실수나, 누락 혹은 의도하지 않은 기술적 오류, 제공된
            자료의 오타에 대한 책임이 없습니다. 그리고 당사는 성 교육 및 성 교육
            자료에 관한 귀하의 사회 윤리 및 도덕적 기준 위반에 대해 책임이
            없습니다.
          </p>
        </div>

        <div className="space-y-3">
          <h3 className="text-xl font-semibold">3. 등록 및 적격성</h3>
          <p>
            앱을 사용하려면, 계정(이하 "계정")을 만들거나 업데이트 해야 할 수
            있습니다. 그리고 귀하의 이름, 성별, 출생일, 이메일 주소 같은 일부
            개인 정보를 제공해야 할 수 있습니다. 이 정보는 당사의 개인정보
            처리방침에 부합하도록 유지되고 이용될 것입니다. 당사의 개인정보
            처리방침은 (메뉴-&gt;개인정보 처리방침)에서 확인할 수 있습니다.
            귀하는 당사에 정확하고 완전한 정보를 제공하며 정보가 바뀌는 경우
            신속히 해당 정보를 업데이트 할 것을 동의합니다.
          </p>
        </div>

        <div className="space-y-3">
          <h3 className="text-xl font-semibold">4. 앱 사용</h3>
          <p>
            귀하가 앱을 통해 제공하는 모든 콘텐츠는 당사의 개인정보 처리방침에
            따라 관리됩니다. 본 협약서와 당사의 개인정보 처리방침 사이에 서로
            불일치하는 부분이 있을 경우, 본 약관이 우선 적용됩니다. 귀하가
            질문이나 응답을 제출할 경우, 본인의 통신 내용, 통신 내용을 게재한
            결과, 공공 영역에서 발견되는 통신 내용 신뢰성에 대한 책임은 전적으로
            귀하에게 있습니다. 회사와 회사의 라이선스 사업자는 공공 영역에서의
            통신으로 인한 결과에 대해 책임이 없습니다. 앱 사용에 관한 하나의
            조건으로, 귀하는 이 협약서에서 금지하는 그 어떠한 목적으로도 본 앱을
            사용하지 않는다는 점에 동의합니다. 귀하는 앱과 관련된 본인의 모든
            행동에 대해 책임이 있습니다. 귀하는 모든 현지, 주, 국가, 국제법과
            규정 및 해당 규제법을 모두 준수해야 합니다. 귀하가 다음의 행위 중
            어떤 한 가지라도 하면, 귀하는 실질적으로 본 협약서를 위반하는 것이
            됩니다. 귀하는 다음과 같은 행위를 하지 않아야 할 것에 동의합니다.
          </p>
          <ol className="list-inside px-3 list-decimal space-y-2">
            <li>
              전매, 임대, 대여, 대출, 라이선스 양도, 배포, 혹은 여타 앱 권리
              이전
            </li>
            <li>앱 수정, 앱 역설계, 앱 디컴파일, 혹은 앱 분해</li>
            <li>
              당사의 서면 허가 없이 앱 복사, 변형, 변경, 수정, 번역 또는 앱 파생
              작업 창출
            </li>
            <li>
              본 약관에 명시 된 외의 방법으로, 네트워크 연결을 통해 타인에게 앱
              사용을 공유하는 것을 포함 (이에만 국한되는 것이 아님) 하여, 앱을
              타인이 사용하도록 허락하는 행위
            </li>
            <li>
              지적재산권 보호를 위한 앱의 기술적 기능 또는 조치를 우회하거나
              무능화하는 행위
            </li>
            <li>
              여하한 관할권의 저작권법에 의해 보호받는 권리와 콘텐츠 파일 및
              기타 작업물에 액세스하는 것을 통제하기 위해 기술적 조치가 취해져
              있음, 그런데 이를 우회 할 목적으로 설계한 디바이스, 프로그램 또는
              서비스를 당 앱과 연계하여 사용하거나, 사용하려고 시도하는 행위
            </li>
            <li>
              경쟁 제품이나 서비스가 사용하거나 사용할 수 있게 하려고 데이터를
              컴파일하기 위해 당 앱에 액세스하거나 당 앱을 사용하는 행위
            </li>
          </ol>
          <p>
            상기 금지된 행위를 하는 경우 귀하의 앱 사용 라이선스는 종료됩니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">5. 앱의 제한된 라이선스</h3>
          <p>
            당사는 본 협약서의 약관에 준하여 귀하가 개인적 비상업적 목적으로
            앱에 액세스하여 앱을 사용할 수 있도록, 귀하에게 개인적이며, 전
            세계에서 통용되며, 폐지할 수 있고, 이전할 수 없는, 비 독점적인
            라이센스를 부여합니다.
          </p>
          <p>
            본 협약서에서 앱에 대해 확실히 부여하지 않은 모든 권리, 자격, 이익은
            회사가 보유합니다. 당사의 소프트웨어, 자격, 상표명, 상표, 서비스
            마크, 로고, 도메인 명, 그리고 (혹은) 당사가 소유한 그 외의 분명한
            브랜드 특색이나 기타 콘텐츠와 관련된 제반 정체성을 귀하가 사용하고자
            하는 경우, 귀하는 당사의 서면 허가를 받아야 합니다. 허가 요청은
            <a href="mailto:marketing@philmedi.com" className="text-blue-500">
              marketing@philmedi.com
            </a>
            로 보내시면 됩니다.
          </p>
          <p>
            의심의 여지를 피하기 위해서, 당사는 우리가 앱과 관련하여 작성하고
            제공하는 모든 텍스트, 이미지, 사진 그리고 제반 데이터 형식 및
            커뮤니케이션 형식을 소유합니다. 당사가 소유하는 것에는 시각적
            인터페이스, 그래픽, 디자인, 사용자 콘텐츠 모음 자료, 사용자 평가
            랭킹 자료 모음, 앱의 다른 모든 요소 및 구성품이 포함 (이것으로 국한
            하는 것은 아님) 됩니다. 여기에 명시적이며 분명하게 제시된 경우를
            제외하고, 당사는 귀하에게 앱 안이나 앱과 관련한 어떠한 명시적 또는
            묵시적 권리를 부여하지 않으며, 앱 및 회사 콘텐츠에 대한 모든 권리는
            당사가 보유합니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">6. 이용 시 본인이 위험 부담</h3>
          <p>
            당사의 목표는 특정 건강 관련 정보를 유저가 보다 쉽고 유용하게 이용할
            수 있도록 하는 것입니다. 그러나 앱은 건강 관련 개선 또는 건강 관련
            결과를 보장할 수 없으며 보장하지 않습니다. 앱 이용, 그리고 앱이
            제시하는 모든 정보, 기간 예측 혹은, 기타 제안 사항을 이용할 때
            발생할 수 있는 위험 부담은 전적으로 귀하의 책임입니다. 당사가 앱을
            통하여 귀하에게 제공하는 데이터, 정보, 추측, 예측의 정확성에 관하여
            당사는 어떤 종류의 의사 표현이나 보장을 하지 않습니다. 그리고 귀하는
            앱이 의료적 과학적 디바이스의 목적과 동일하게 일치하거나 그런 목적을
            수행하기 위해 설계되지 않았다는 사실에 동의합니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">7. 패스워드</h3>
          <p>
            귀하에게는 인준 받지 않은 사람이 귀하의 앱 패스워드나 계정에
            접근하지 못하도록 상당한 조치를 취할 책임이 있습니다. 귀하는 다음에
            관하여 전적으로 본인이 책임을 집니다. (1) 신청자 명 유포 및 이용
            통제하기, 스크린 명 및 패스워드 유포 및 이용 통제하기 (2) 귀하의 앱
            계정과 패스워드 접근과 이용을 인준, 감시, 통제하기 (3) 귀하의
            계정이나 패스워드가 훼손 되었다 생각하는 경우, 혹은 패스워드를
            비활성화 해야 할 상당한 이유가 있는 경우 회사에 신속히 알리기
            <a href="mailto:marketing@philmedi.com" className="text-blue-500">
              marketing@philmedi.com
            </a>
            를 이용 당사에 이메일을 보내주십시오. 앱 운영에 관여하는 회사, 모든
            관련 개인 또는 단체에게 귀하는 앱 운영과 관련된 귀하의 정보를 전송,
            감시, 검색, 저장, 이용할 권리를 부여합니다. 회사는 귀하가 제출한
            모든 정보에 대하여 책임과 의무를 질 수 없으며, 지지 않습니다. 귀하나
            제삼자가 앱을 이용해서 전송하거나 받은 정보를 이용하거나 오용하는
            것에 대해서도 마찬가지 입니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">8. 보증 면책 조항</h3>
          <p>
            회사는 다양한 지역에서 앱을 통제하고 운영하지만 모든 지역에서 본
            앱이 적절하며 이용 가능하다는 뜻은 아닙니다. 앱이나 앱 특색은 지역에
            따라서 이용이 불가능할 수도 있으며, 다를 수도 있습니다.
          </p>
          <p>
            당 앱은 "현 상태대로 " "현재 이용 가능한 대로" 제공됩니다. 자격,
            비법률위반, 상품성, 특정 목적을 위한 적합성, 그리고 수행과정 혹은 상
            거래 관습상 묵시적으로 용인하는 보증을 포함한 (여기에 국한 되지 만은
            안음) 제반 종류의 보증이나 표시 없이 제공됩니다. 법이 별도로
            요구하는 정도를 제외하고, 제반 표시 및 보증은 분명히 면책됩니다.
          </p>
          <p>
            당 회사, 당 회사의 관리자, 직원, 대리인들, 대표자, 납품업자,
            협력업체, 콘텐트 제공자는 다음을 보증하지 않습니다. (A) 앱은 모든
            특정 시간과 지역에서도 안전하고 이용 가능할 것이다. (B) 모든
            결함이나 에러가 수정될 것이다. (C) 앱이나 앱을 통해서 구한 모든
            컨텐트에 바이러스가 없으며, 해로운 구성품이 없다. (D) 앱을 이용한
            결과가 귀하의 요구 조건을 충족할 것이다. 앱 사용의 위험 부담은
            전적으로 귀하의 책임입니다.혹은 (E) 비밀 채팅 및 앱에서 또는 앱을
            통해 제삼자 제공한 콘텐츠, 텍스트, 이미지, 소프트웨어, 그래픽 또는
            통신의 정확성, 신뢰성 또는 완성도에 대한 위험 부담도 본인의
            책임입니다. 일부 주와 국가에서는 묵시적 보증에 대한 제한을 허락하지
            않으므로, 상기 제한 사항은 귀하에게 적용되지 않을 수도 있습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">9. 책임 제한</h3>
          <p>
            회사나, 담당자나 관리인, 대리인, 계열사, 직원, 광고업자, 혹은 데이터
            제공자는 어떠한 상황에서도 간접적 피해, 특수 손상, 우발적인 손상,
            간접 손해, 징벌적인 손해 (용도 상실, 이윤 상실, 데이터 상실 등,
            포함) 배상 책임을 지지 않습니다. 계약 수행 중이나 불법 행위(과실 등
            포함), 형평법이나 당 앱 사용과 관련하여 야기되는 제반 사항으로
            발생한 손해 배상의 경우도 마찬가지 입니다. 본 약관이나 본 약관과
            관련하여 발생하는 회사의 전체 책임 혹은 앱 사용이나 앱 사용 불가로
            발생하는 회사의 천체 책임은 어떤 경우에도 귀하가 앱 사용을 위해서
            회사에 지불한 금액, 혹은 귀하가 회사에 해당하는 바 지불할 의무가
            없는 경우 일백달러 ($ 100)를 초과할 수 없습니다. 일부 관할권의 경우
            책임 제외 또는 제한 조치를 허용하지 않는 경우도 있습니다. 이 경우
            상기 제한 조치는 귀하에게 적용되지 않을 수 있습니다. 당사나 혹은
            앱에서 설명한 제삼자는 귀하의 앱 사용이나 오용으로 야기된 개인
            부상(사망 포함)에 대하여 책임을 지지 않습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">10. 모바일 디바이스 사용</h3>
          <p>
            귀하가 모바일 디바이스를 통하여 앱을 사용하는 경우, 통신사의 일반
            요금과 수수료(문자 요금 및 데이터 요금 등)가 적용될 수 있음을
            유념하십시오.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">11. 귀하의 사용 후기</h3>
          <p>
            당사는 귀하의 앱 사용 후기를 환영합니다. 분명히 달리 명시되어 있지
            않는 한, 귀하가 당사에 보내거나 앱스토어에 게시한 내용은 기밀이 아닌
            것으로 간주합니다. 귀하는 당사의 재량권으로 그러한 콘텐츠를 공개할
            수 있다는 사실에 동의합니다. 귀하는 당사가 귀하의 콘텐츠를 무료로
            이용, 개정, 수정, 조정, 문맥 변경, 또는 적절하다 판단되는 방식으로
            변경할 수 있도록 당사에게 권한을 부여함을 동의합니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">12. 시행권</h3>
          <p>
            우리는 앱에 대한 액세스나 앱의 사용을 모니터링할 의무가 없습니다.
            그러나 우리는 앱을 운영 및 유지 관리하고 본 계약을 준수하며 적용
            가능한 법적 요구 사항을 준수 할 목적으로 그렇게 할 권리를
            보유합니다. 당사는 법 집행 당국에 불법 행위를 공개할 수 있습니다.
            합당한 법 절차에 따라서, 당사는 법을 위반하는 유저를 기소하기 위해
            법 집행 당국과 협력할 수 있습니다. 당사는 귀하의 콘텐츠나 앱 사용이
            본 협약서에 반하거나 본 협약서를 위반하고 있음이 당사의 단독
            재량으로 판단되는 경우, 당사는 통지 없이 언제든지 당사의 단독
            재량으로 앱에 게시된 제반 콘텐츠 및 앱에 대한 액세스을 제거하거나
            비활성화할 권리를 보유합니다( 이 권한 보유는 필수 사항은 아님).
            <br />
            회사는 상기 설명한 활동을 수행하거나 수행하지 않은 것에 대해 앱의
            유저나 기타 개인 또는 단체에 대하여 어떤 책임이나 의무를 지지
            않습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">13. 앱 변경</h3>
          <p>
            당사는 귀하에게 사전 고지하지 않고 수시로, 앱을 변경, 확장, 개선할
            수 있습니다. 당사는 또한 언제라도 앱 일부나 전체의 운영을 중단할 수
            있습니다. 혹은 앱의 특정 기능을 선별적으로 비활성화할 수 있습니다.
            귀하가 앱을 사용한다고 하여, 귀하에게 앱의 지속적 제공 및 유용성을
            요구할 권한이 있는 것은 아닙니다. 당사는 당사의 절대적 단독 재량권을
            발휘하여, 귀하에 대한 지속적 의무나 책임 없이, 앱 또는 일부 기능을
            수정하거나 제거할 수 있습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">14. 보상</h3>
          <p>
            귀하는 귀하의 본 협약서 위반으로 인해 발생하거나 발생한 것으로
            추정되는 합리적인 법률 회계 수수료를 포함하여 모든 청구, 조치 또는
            요구, 책임 및 합의에 대해 손해가 없도록 회사, 임원, 이사, 직원,
            대리인, 라이선스 제공자 및 공급업체를 변호, 보상 및 지지하는 데
            동의합니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">15. 기타</h3>
          <p>
            조치의 청구 또는 사유가 발생한 후 앱 사용과 관련하여 취하려는 조치의
            모든 사유는 1년 이내에 시작된 것이어야 합니다.
          </p>
          <p>
            어떠한 이유로든 관할 법원에서 협약서 또는 그 일부의 조항을 시행
            불가한 것으로 판단하는 경우, 해당 조항은 본 협약서의 의도를 최대한
            반영할 수 있는 최대 허용치까지 시행하도록 합니다. 협약서의 나머지
            조항은 계속 효력을 발휘합니다. 본 협약서의 인쇄본은 사법 및 행정
            절차에서 증거로 허용될 수 있습니다.
          </p>
          <p>
            본 협약서에 제시된 조항 중 어느 것을 회사가 포기한다 하여, 그것을
            그러한 조항 또는 다른 조항을 추가로 또는 지속적으로 포기한다는
            의미로 간주해서는 안됩니다. 회사가 본 협약서 하의 권리나 조항을
            주장하지 않는다 하여, 그것이 회사의 권리 또는 조항을 포기하는 것에
            해당하는 것은 아닙니다. 어떤 이유로든 관할 법원의 법정이나 기타
            재판소에서 본 협약서의 조항 중 어떤 조항을 무효, 불법 또는 시행
            불가한 것으로 판단하는 경우, 해당 조항은 제거하거나 최소로
            제한합니다. 협약서의 나머지 조항은 계속 효력을 발휘합니다.
          </p>
          <p>
            본 협약서가 종료될 시, 종료 이후에도 그 특성상 존속해야할 제반
            조항은 제한 없이 존속 될 것입니다. 여기에 포함되는 조항은 소유권
            조항, 보증 면책 조항, 책임 제한 조항입니다.
          </p>
          <p>
            본 협약서와 관련된 당사자들의 모든 청구는 개별적인 소송으로 진행될
            것이며, 당사자들이 서면으로 사전 동의하지 않는 한, 어떤 청구도
            통합하거나 단체로 처리되지 않습니다.
          </p>
          <p>
            당사는 언제라도 서비스를 거절하고, 계정을 폐쇄하고, 적격성 요구
            조건을 변경할 수 있습니다.
          </p>
        </div>
        <div className="space-y-3">
          <h3 className="text-xl font-semibold">질문 및 의견</h3>
          <p></p>
          <p></p>
        </div>
        <div className="space-y-3">
          <p>
            앱의 제 분야나 또는 본 이용 약관의 제 분야에 관해서 진술할 코멘트나
            질문이 있으신 경우, 혹은 당사의 지원이 필요하거나 혹은 당사에 청구할
            사항이 있으신 경우{' '}
            <a href="mailto:marketing@philmedi.com" className="text-blue-500">
              marketing@philmedi.com
            </a>
            로 연락 하십시오.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
